module.exports = __webpack_public_path__ + "assets/pixelyoursite.69dd6480.svg";